import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list = [
  {
    id: 'PEC',
    value: 'PEC',
  },
  {
    id: 'AR_REGISTERED_LETTER',
    value: 'Raccomandata AR',
  },
];

interface TypeTransactionListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
}

const TypeTransactionListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo Trasmissione',
}: TypeTransactionListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="type-transaction-list-label">{label}</InputLabel>
      <PmiSelect
        labelId="type-transaction-list-label"
        id="type-transaction-list"
        name="type-transaction-list"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeTransactionListComponent.displayName = 'type transaction list component';

const TypeTransactionList = memo(TypeTransactionListComponent);

export default TypeTransactionList as typeof TypeTransactionListComponent;
